import { render, staticRenderFns } from "./POSfast.vue?vue&type=template&id=68be1747&scoped=true"
import script from "./POSfast.vue?vue&type=script&lang=js"
export * from "./POSfast.vue?vue&type=script&lang=js"
import style0 from "./POSfast.vue?vue&type=style&index=0&id=68be1747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be1747",
  null
  
)

export default component.exports